module.exports = __webpack_public_path__ + "img/Perspektive 11-31-07.ae8ffe02.jpg";